import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { captureTouch, trackCommercial, classifyPath } from '../utils/attribution';

/**
 * Mount once near the app root. Captures the acquisition touch on first load and
 * emits a commercial page-view event on navigation to commercially meaningful
 * routes only (programme, credential family, AI governance, accreditation,
 * verification, trust, comparison). Noise routes are ignored.
 */
export default function CommercialTracker() {
  const { pathname } = useLocation();
  const last = useRef(null);

  useEffect(() => { captureTouch(); }, []);

  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    const hit = classifyPath(pathname);
    if (!hit) return;
    const [eventType, category] = hit;
    // programme_view title enrichment is done by analytics.trackProgrammeView;
    // here we only emit the generic categorised view (slug from path).
    const slug = pathname.split('/').filter(Boolean).pop();
    trackCommercial(eventType, { pageCategory: category, props: { slug } });
  }, [pathname]);

  return null;
}
